import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div`
  position: relative;
  font-size: 1.4rem;
  font-weight: bold;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 1px;
  color: ${props => props.theme.colors.bodyText};
  margin: 0 auto;
  width: fit-content;
  z-index: 1;
`;

const PCBox = styled(DefaultBox)`

`;

const MobileBox = styled(DefaultBox)`
  font-size: 0.9rem;
`;

export const HomepageHeaderArenaTitleDefaultBox = styledByDevice(PCBox, MobileBox);
